import { render } from "./Claims.vue?vue&type=template&id=2c26de9d&scoped=true"
import script from "./Claims.vue?vue&type=script&lang=js"
export * from "./Claims.vue?vue&type=script&lang=js"

import "./Claims.vue?vue&type=style&index=0&id=2c26de9d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c26de9d"]])

export default __exports__